import { render } from "./OverviewView.vue?vue&type=template&id=3c7982f0&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"

import "./OverviewView.vue?vue&type=style&index=0&id=3c7982f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7982f0"]])

export default __exports__